import { render, staticRenderFns } from "./RecruitmentDetails.vue?vue&type=template&id=e7628fee&scoped=true"
import script from "./RecruitmentDetails.vue?vue&type=script&lang=js"
export * from "./RecruitmentDetails.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentDetails.vue?vue&type=style&index=0&id=e7628fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7628fee",
  null
  
)

export default component.exports